<template>
<!--     subdomain == 'lab' ? 'lab-site-mode' : '', --> 
  <div :class="['media-boxes', 
    siteIsLab == true ? 'media-boxes-lab' : '',    
    dimensions.width < 600 ? 'hide' : '']">
    <a
      v-for="item in children"
      :key="item.title"
      @click.prevent="clickHandler(item)"
      href="#media-boxes"
      class="media-boxes--thumb"
      :style="`background-image:url(${parseSrc(item.image)})`"
    >
      <div class="box-content">
        <i v-if="isVideo(item)" :class="['media-icon', 'play-circle-icon']">
          <i class="fal fa-triangle"></i>
        </i>
        <i v-else :class="['media-icon', 'fal', 'plus-icon']"></i>

        <h4 v-if="item.title">
          <!-- <i class="fal fa-play-circle"></i> -->
          <span v-text="item.title"></span>
        </h4>
      </div>

      <!-- <div class="media-boxes--thumb--img">
       
      <!-- <img
          :src="parseSrc(item.image)"
          :alt="item.title"
          :title="item.title"
        /> -->
      <!--`${$imageFolder}/${item.image}`-->
      <!-- </div> -->
    </a>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { subdomain } from "@/utils";

export default {
  data() {
    return {
	    siteIsLab: false
    };
  },
  props: {
    children: {
      type: Array,
      required: true
    }
  },
  watch: {
    mediaChildren() {
      this.setMediaChildrenToGallery();
    }
  },
  mounted() {
    // console.log("MEDIA CHILDREN > ", this.mediaChildren);
    this.setMediaChildrenToGallery();
    this.siteIsLab  = this.isLabPage();
  },
  methods: {
    ...mapActions(["setGalleryIndex", "setGalleryChildren"]),
    isLabPage() 
    {
	  	var routePart = this.$route.path.toLowerCase().indexOf('/lab');
        var __subdomain = subdomain();  		  
      	return routePart ===0 || routePart === 6 || __subdomain === 'lab'//in case of /Patient or de-de/lab
    },
    parseSrc(img) {
      // console.log(" >this.$imageFolder >> ", this.$imageFolder);
      if (/http/.test(img)) {
        return img;
      } else {
        // if (img.indexOf("/") !== 0) {
        //   img = "/" + img;
        // }
        return `${this.$imageFolder}/${img}`;
      }
    },
    isVideo(item) {
      return item.media_type_id === 5;
    },
    setMediaChildrenToGallery() {
      this.$nextTick(function() {
        if (this.mediaChildren && this.mediaChildren.length) {
          this.setGalleryChildren(this.mediaChildren);
        }
      });
    },
    clickHandler(item) {
      if (this.isMedia(item)) {
        let id = item.id,
          index = _.findIndex(this.mediaChildren, { id });
        console.log("ITEM > ", item);
        this.setGalleryIndex(index);
      } else if (this.isExternalLink) {
        window.open(item.url, "_blank");
      } else {
        this.$router.push(item.url);
      }
    },
    isMedia(item) {
      return item.url && /(vimeo|youtube)/g.test(item.url);
    },
    isExternalLink(item) {
      return item.url && /http/.test(item.url);
    }
  },
  computed: {
    ...mapState(["dimensions"]),
    mediaChildren() {
      return _.filter(
        this.children,
        child => child.url && /(vimeo|youtube)/g.test(child.url)
      );
    }
  }
};
</script>
<style lang="stylus">
.media-boxes
  position absolute
  bottom 0
  width 100%
  background #fff
  min-height 10vh
  _flex(column, nowrap, flex-start, flex-start)
  +above(815px)
    position relative
    _flex(row, wrap, stretch, space-between)
  &--thumb
    position relative
    flex 1
    background-repeat no-repeat
    background-position center
    background-size cover
    cursor pointer
    _flex(column, wrap, center,center)
    height 12vh
    min-height 120px
    border-top 1px solid #fff
    border-bottom 1px solid #fff
    &:nth-child(2)
      +above(815px)//dubi
        border-left 1px solid #fff
        border-right 1px solid #fff
    .box-content
      max-width 96%
      position relative
      z-index 10
      // &:after
      //   content ''
      //   position absolute
      //   bottom -5px
      //   left 50%
      //   transform translateX(-50%)
      //   width 80%
      //   height 1px
      //   background rgba(#fff, 0.99)
      //   transition width 0.65s ease-out-expo, transform 0.65s ease-out-expo
      h4
        font-size responsive 18px 28px
        font-range 600px 1900px
        text-align center
        color #fff
        transition opacity 0.65s ease-out-expo, transform 0.65s ease-out-exp
    +below(815px)
      min-height 60px
    +above(815px)
      flex 0 0 33.3333%
    &:after
      content ''
      position absolute 0 0 0 0
      background-color rgba(blue_6,0)
      z-index 9
      transition background 0.65s ease-out-expo
    &:nth-child(1):after
      background-color c_dk_blue
    &:nth-child(2):after
      background-color blue_6
    &:nth-child(3):after
      background-color blue_4
    .media-icon
      opacity 0
      backface-visibility hidden
      center()
      transform translate(-50%, -100%) scale(0.3)
      z-index 9
      font-size responsive 76px 96px
      color rgba(#fff, 0.9)
      will-change opacity, transform, box-shadow
      transition opacity 0.7s ease-out-expo, transform 0.7s ease-out-expo, box-shadow 0.7s ease-out-expo
      &.play-circle-icon
        box-shadow 0 0 5px rgba(0,0,0,0)
        display inline-flex
        font-size responsive 20px 34px
        align-items center
        justify-content center
        round(90)
        border 3px solid rgba(#fff, 0.8)
        i
          transform rotate(-29deg) translate(-5%, -5%)
      &.plus-icon
        width 80px
        height @width
        &:after
        &:before
          content ''
          width 100%
          background rgba(#fff, 0.8)
          height 3px
          position absolute
          top 50%
          left 50%
          transform translate(-50%,-50%)
        &:after
          transform translate(-50%,-50%) rotate(-90deg)
        +below(815px)
          width 50px

    +below(815px)
      &:after
        background-color rgba(c_dk_blue, 0.6) !important
      .media-icon
        opacity 0.9
        transform translate(-50%, -75%) scale(0.5)
      .box-content
        h4
          transform translateY(75%)
          opacity 0.9
        &:after
          width 400%
          transform translate(-50%, 45px)
    +desktop()
      &:hover
        &:after
          background-color rgba(c_dk_blue, 0.6)
        .media-icon
          opacity 0.8
          transform translate(-50%, -50%) scale(0.5)
          &.play-circle-icon
            box-shadow 0 0 35px rgba(0,0,0,0.6)
          &.plus-icon
            &:after
            &:before
              box-shadow 0 0 35px rgba(0,0,0,0.6)

        .box-content
          h4
            transform translateY(50%)
            opacity 0
          &:after
            width 400%
            transform translate(-50%, 45px)
  +below(815px)
    display block
    &--thumb
      height 120px
      min-height auto
      flex auto

.media-boxes-lab
  +below(815px)
      top 0px !important
      position initial !important
      display contents
    h4
    +below(815px)
      opacity 1 !important
</style>
